module.exports = __webpack_public_path__ + "141711e9e499b7dc49365a8db8e3ee9d.png";